const BaseActionTypes = (resource) => ({
  CREATE: `${resource}/CREATE`,
  GET_LIST: `${resource}/GET_LIST`,
  GET_ONE: `${resource}/GET_ONE`,
  UPDATE_ONE: `${resource}/UPDATE_ONE`,
  DELETE_ONE: `${resource}/DELETE_ONE`,
});

export default BaseActionTypes;
